import { render, staticRenderFns } from "./MaterialTable.vue?vue&type=template&id=e48cf386&scoped=true&"
import script from "./MaterialTable.vue?vue&type=script&lang=js&"
export * from "./MaterialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48cf386",
  null
  
)

export default component.exports